/**
 * Web Style Import
 *
 */

import './style/dnb-lists.scss'
